import React, { useEffect } from 'react';

const Icon = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: Icon is not implemented yet.');
  }, []);
  return (
    <>
  { /*Icon */} 
 </>
  );
};

export { Icon };

const Button = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: Button is not implemented yet.');
  }, []);
  return (
    <div>
      {/* Button placeholder */}
    </div>
  );
};

export { Button };